import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Button,
  Progress
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import classnames from "classnames";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import "jspdf-autotable";
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css'
import * as XLSX from "xlsx";

import {
  getBlogs as onGetBlogs,
  addBlog as onAddBlog,
  updateBlog as onUpdateBlog,
  deleteBlog as onDeleteBlog,
} from "store/contacts/actions";
import { isEmpty } from "lodash";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

//redux
import { useSelector, useDispatch } from "react-redux";

const API_URLS = {
  // Sözlükleri çek
  listQuestionTypes: "https://beeducationadmin.stechomeyazilim.info:8093/getQuestionTypeBee/select",          // returns [{ID, Question_Type_Sort, Question_Type_Title}]
  listLevels:        "https://beeducationadmin.stechomeyazilim.info:8093/getLevelEfso/select",                  // returns [{ID, Level_Title}]
  listSubCats:       "https://beeducationadmin.stechomeyazilim.info:8093/getSubCategoryBee/select",   // returns [{ID, Category_SubCategory_Number, Category_ID, Category_SubCategory_Title}]
  listCategories:    "https://beeducationadmin.stechomeyazilim.info:8093/getLessonEfso2/select",               // returns [{ID, Category_Title}]  // (SINAV TİPİ için)

  // Var olan Question_Code kontrolü
  findQuestionByCode: (code) => `https://beeducationadmin.stechomeyazilim.info:8093/getQuestionFindByCode/select/${code}`,

  // Kayıt uçları (alan isimleri tabloya göre)
  addQuestion: "https://beeducationadmin.stechomeyazilim.info:8093/addQuiz/send",                      // body: {...Question fields...}  returns {ok:true, id: <QuestionID>} veya {value:[{ID:...}]}
  addAnswer:   "https://beeducationadmin.stechomeyazilim.info:8093/addQuizAnswer/send",               // body: {Question_ID, Question_Answer_Title, TrueCheck}
};


// Türkçe güvenli normalize
const norm = (s) => String(s || "")
  .toUpperCase()
  .replaceAll("İ","I").replaceAll("Ş","S").replaceAll("Ğ","G")
  .replaceAll("Ü","U").replaceAll("Ö","O").replaceAll("Ç","C")
  .replace(/\s|-/g, "");

// KOD AÇIKLAMA sayfasındaki harf → sınav adı


const ContactsList = props => {
  const tableRef = useRef(null);

  //meta title
  document.title = "Sorular | BeeEducation ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getFileName, setFileName] = useState('');
  const [activeTab, setActiveTab] = useState(1);

  // Cevap seçeneklerini yönetmek için kullanılan state
  const [options, setOptions] = useState([]);

  // Formik, ilk sekmedeki soru bilgilerinin validasyonu için kullanılacak
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      subCategory: (contactEdit && contactEdit.Question_SubCategory_Sub_ID) || "",
            title: (contactEdit && contactEdit.Question_Title) || "", // Soru metni için eklendi

    },
    validationSchema: Yup.object({
      subCategory: Yup.string().required("Lütfen bir kategori seçin."),
            title: Yup.string().required("Lütfen soruyu girin."), // Soru metni validasyonu eklendi

    }),
    onSubmit: values => {
      // Formik'in submit'i sadece adımlar arası geçişte validasyon için kullanılacak
      // Bu fonksiyon doğrudan bir şey yapmayacak, bunun yerine İleri butonu tetikleyecek
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.blogs,
  }));

  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [getCategory, setCategory] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);

  // Adımlar arası geçiş fonksiyonu
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      // İleri giderken validasyon kontrolü yap
      if (tab > activeTab) {
        validation.validateForm().then((errors) => {
          if (isEmpty(errors)) {
            setActiveTab(tab);
          } else {
            // Zorunlu alanları doldurması için Formik'in touced durumunu güncelle
            validation.setTouched({
              subCategory: true,
            });
            showToast("Hata", "Lütfen ilk adımdaki tüm zorunlu alanları doldurun.", false);
          }
        });
      } else {
        // Geri giderken validasyon yapma
        setActiveTab(tab);
      }
    }
  };
  
  // Tablo kolonlarının tanımı
  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => <input type="checkbox" className="form-check-input" />,
      },
     

      {
        Header: "Soru",
        accessor: "Question_Title",
        Cell: ({ cell: { value } }) => value || "N/A",
      },


       {
        Header: "Sınav Tipi",
        accessor: "Category.Category_Title",
        Cell: ({ cell: { value } }) => value || "N/A",
      },


       {
        Header: "Soru Tipi",
        accessor: "Question_Type.Question_Type_Title",
        Cell: ({ cell: { value } }) => value || "N/A",
      },

      {
        Header: "Alt Kategori",
        accessor: "Category_SubCategory.Category_SubCategory_Title",
        Cell: ({ cell: { value } }) => value || "N/A",
      },

        {
        Header: "Seviye",
        accessor: "Level.Level_Title",
        Cell: ({ cell: { value } }) => value || "N/A",
      },


           {
        Header: "İlk Deneme",
        accessor: "Sabit",
        Cell: ({ cell: { value } }) => value || "N/A",
      },

      {
        Header: "Cevaplar",
        accessor: "Question_Answer", // Bu accessor, API'den gelen nested array'i hedefler
        Cell: ({ cell: { value } }) => (
          <div>
            {/* HATA DÜZELTMESİ: 'value' bir dizi ise .map() çağır, değilse "Cevap Yok" yaz. */}
            {Array.isArray(value) && value.length > 0 ? (
              value.map(item => (
                <div key={item.ID}> {/* Her cevap için benzersiz veritabanı ID'sini key olarak kullan */}
                  <span className={item.TrueCheck ? "text-success fw-bold" : "text-danger"}>
                    {item.Question_Answer_Title}
                  </span>
                </div>
              ))
            ) : (
              <span className="text-muted">Cevap Yok</span>
            )}
          </div>
        ),
      },
      {
        Header: "İşlemler",
        Cell: cellProps => (
          <div className="d-flex gap-3">
          {/** 
            <Link
              to="#"
              className="text-success"
              onClick={() => handleUserClick(cellProps.row.original)}
            >
              <i className="mdi mdi-pencil font-size-18" id={`edittooltip-${cellProps.row.id}`} />
              <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.id}`}>Düzenle</UncontrolledTooltip>
            </Link>
            */}
            <Link
              to="#"
              className="text-danger"
              onClick={() => onClickDelete(cellProps.row.original)}
            >
              <i className="mdi mdi-delete font-size-18" id={`deletetooltip-${cellProps.row.id}`} />
              <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.id}`}>Sil</UncontrolledTooltip>
            </Link>
          </div>
        ),
      },
    ],
    []
  );



  useEffect(() => {
    if (isEmpty(users)) {
      dispatch(onGetBlogs());
    }
  }, [dispatch, users]);
  
  // Modal kapandığında tüm state'leri sıfırlayan fonksiyon
  const resetModalState = () => {
    setEditContact(null);
    setIsEdit(false);
    setActiveTab(1);
    setOptions([]);
    setFileName('');
    validation.resetForm();
  };

     const handleClick = () => {
    document.getElementById('fileInput').click();
  };

  const toggle = () => {
    if (modal) {
      resetModalState();
    }
    setModal(!modal);
  };

  // Düzenle butonuna tıklandığında çalışır
  const handleUserClick = (user) => {
    setIsEdit(true);
    setEditContact(user);
    validation.setFieldValue("subCategory", user.Question_SubCategory_Sub_ID);
    setFileName(user.Question_Title_Image || '');
    const loadedOptions = user.Question_Answer ? user.Question_Answer.map(ans => ({
      id: ans.ID,
      text: ans.Question_Answer_Title,
      correct: ans.TrueCheck,
    })) : [];
    setOptions(loadedOptions);
    toggle();
  };

  const onClickDelete = user => {
    setContact(user);
    setDeleteModal(true);
  };
  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteBlog(contact.ID));
    }
    setDeleteModal(false);
  };
  const handleUserClicks = () => {
    setIsEdit(false);
    toggle(); // toggle fonksiyonu zaten resetModalState'i çağırıyor
  };
  
  // Dropzone Handlers
  const getUploadParams = ({ file }) => {
      const body = new FormData();
      body.append('dataFile', file);
      return { url: 'https://megaadmin.stechomeyazilim.info:8080/uploadfile', body };
  };
  const handleChangeStatus = ({ meta, xhr, remove }, status) => {
    if (status === 'done') {
        const result = JSON.parse(xhr.response);
        setFileName(result.file.filename);
        showToast("Başarılı", `${meta.name} yüklendi.`, true);
    } else if (status === 'removed') {
        setFileName('');
    }
  };

  // SEÇENEK YÖNETİMİ FONKSİYONLARI
  const addOption = () => setOptions([...options, { id: Date.now(), text: '', correct: false }]);
  const removeOption = (id) => setOptions(options.filter(option => option.id !== id));
  const handleOptionTextChange = (id, newText) => setOptions(options.map(option => option.id === id ? { ...option, text: newText } : option));
  const setCorrectOption = (id) => setOptions(options.map(option => ({ ...option, correct: option.id === id })));

  // KAYDETME FONKSİYONU
// contacts-list.js dosyanızdaki bu fonksiyonu güncelleyin

const handleFinalSubmit = async () => {
    // 1. Cevap seçenekleri için validasyonlar (bu kısım doğru)
    if (options.length < 2) {
      showToast("Hata", "En az 2 seçenek eklemelisiniz.", false);
      return;
    }
    if (!options.some(opt => opt.correct)) {
      showToast("Hata", "Lütfen bir doğru cevap seçin.", false);
      return;
    }

    // 2. Sunucuya gönderilecek ana soru verisini oluştur
    // Not: Formik state'inizde Question_Type_ID, Level_ID gibi alanların da olması gerekir.
    const questionPayload = {
        Question_Title: validation.values.title,
        Question_Desc: validation.values.description || null, // Formunuza açıklama alanı eklediyseniz
        Question_Category_ID: validation.values.categoryId || null,
        Question_Type_ID: validation.values.typeId || null,
        Question_SubCategory_ID: validation.values.subCategoryId || null,
        Level_ID: validation.values.levelId || null,
        Blank: false, // Manuel eklenen sorular şimdilik Blank değil
        Sabit: validation.values.sabit || null,
    };

    try {
        let questionId;

        if (isEdit) {
            // Düzenleme mantığı şimdilik devre dışı
            showToast("Bilgi", "Düzenleme modu henüz aktif değil.", true);
            return;
        } 
        
        // YENİ EKLEME MANTIĞI
        
        // 3. Adım 1'de düzelttiğimiz doğru API adresini kullanarak soruyu POST et
        const questionResponse = await axios.post(API_URLS.addQuestion, questionPayload);

        // 4. Adım 2'de bahsettiğimiz doğru yerden ID'yi oku
        questionId = questionResponse.data.ID;
        
        if (!questionId) {
            throw new Error("Soru oluşturuldu ancak ID'si alınamadı.");
        }

        // 5. Cevapları bu yeni Soru ID'sine bağlayarak kaydet
        const answerPromises = options.map((option, index) => {
            const answerPayload = {
                Question_ID: questionId,
                Question_Answer_Title: option.text,
                TrueCheck: option.correct,
                Blank_Index: 0,
                SortOrder: index + 1
            };
            return axios.post(API_URLS.addAnswer, answerPayload);
        });

        await Promise.all(answerPromises);

        showToast("Başarılı", "Soru ve cevaplar kaydedildi.", true);
        toggle();
        dispatch(onGetBlogs()); // Listeyi yenile

    } catch (error) {
        console.error("Kaydetme sırasında hata:", error);
        const errorMsg = error.response?.data?.message || "İşlem sırasında bir hata oluştu.";
        showToast("Hata", errorMsg, false);
    }
};
  
async function buildDictionaries() {
  const [typesRes, levelsRes, subcatsRes, catsRes] = await Promise.all([
    axios.get(API_URLS.listQuestionTypes),
    axios.get(API_URLS.listLevels),
    axios.get(API_URLS.listSubCats),
    axios.get(API_URLS.listCategories),
  ]);

  const types = typesRes.data || [];
  const levels = levelsRes.data || [];
  const subcats = subcatsRes.data || [];
  const cats = catsRes.data || [];

  const typeBySort = new Map();
  types.forEach(t => typeBySort.set(Number(t.Question_Type_Sort), t.ID));

  const levelByTitle = new Map();
  levels.forEach(l => levelByTitle.set(norm(l.Level_Title), l.ID));

  const subcatByNumber = new Map();
  subcats.forEach(s => subcatByNumber.set(Number(s.Category_SubCategory_Number), s.ID));

  // --- DEĞİŞİKLİK BURADA ---
  // Category_Title yerine Category_Code'a göre bir sözlük oluşturuyoruz.
  const catByCode = new Map();
  cats.forEach(c => {
    if (c.Category_Code) { // Category_Code boş değilse ekle
      // Kodları büyük harfe çevirerek tutarlılığı sağlıyoruz (örn: 'y' -> 'Y')
      catByCode.set(c.Category_Code.toUpperCase(), c.ID);
    }
  });

  // Geriye 'catByTitle' yerine 'catByCode' döndürüyoruz.
  return { typeBySort, levelByTitle, subcatByNumber, catByCode };
}


  function showToast(title, message, isSuccess) {
    toastr.options = { positionClass: "toast-top-right", timeOut: 5000, progressBar: true, closeButton: true };
    if (isSuccess) toastr.success(message, title);
    else toastr.error(message, title);
  }

      const [uploadModalOpen, setUploadModalOpen] = useState(false);
      const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);


// ====================================================================
// YARDIMCI FONKSİYONLAR
// ====================================================================

async function postWithRetry(url, body, { retries = 3, baseDelay = 500 } = {}) {
  let attempt = 0;
  while (true) {
    try {
      return await axios.post(url, body);
    } catch (err) {
      attempt++;
      if (attempt > retries) throw err;
      const delay = baseDelay * Math.pow(2, attempt - 1);
      console.warn(`[RETRY] API isteği başarısız (deneme ${attempt}/${retries}). ${delay}ms sonra tekrar denenecek...`);
      await sleep(delay);
    }
  }
}

/**
 * Verilen görevleri (asenkron fonksiyonlar) belirli bir paralellikte çalıştırır.
 * @param {Array<Function>} items - Çalıştırılacak asenkron fonksiyonların dizisi.
 * @param {Function} worker - Her bir öğeyi işleyecek fonksiyon.
 * @param {object} options - { concurrency: aynı anda çalışacak görev sayısı, onProgress: ilerleme callback'i }
 * @returns {Promise<Array>} - Tüm görevlerin sonuçları.
 */
async function uploadInBatches(items, worker, { concurrency = 5, onProgress } = {}) {
  let inFlight = 0;
  let i = 0;
  let done = 0;
  const results = [];
  
  return new Promise((resolve) => {
    const next = () => {
      // Aynı anda çalışan görev sayısı 'concurrency' limitinin altındaysa ve hala işlenecek öğe varsa yeni görev başlat
      while (inFlight < concurrency && i < items.length) {
        const item = items[i++];
        inFlight++;
        
        worker(item)
          .then(res => results.push({ status: 'fulfilled', value: res }))
          .catch(err => results.push({ status: 'rejected', reason: err }))
          .finally(() => {
            inFlight--;
            done++;
            if (onProgress) {
              onProgress(done, items.length);
            }
            // Tüm görevler tamamlandığında Promise'i sonlandır
            if (done === items.length) {
              resolve(results);
            } else {
              next(); // Bir sonraki görevi tetikle
            }
          });
      }
    };
    next(); // İlk görevleri başlat
  });
}

const handleFileUpload = async (e) => {
  const file = e.target?.files?.[0];
  if (!file) return;

  // ========================= Helpers =========================
  const norm = (s) => String(s || "")
    .toUpperCase()
    .replaceAll("İ","I").replaceAll("Ş","S").replaceAll("Ğ","G")
    .replaceAll("Ü","U").replaceAll("Ö","O").replaceAll("Ç","C")
    .replace(/\s|-/g, "");
  const normHeader = (s) => norm(s).replace(/\./g,"").replace(/ /g,"");
  const safeCellString = (v) => (v == null ? "" : String(v).trim());

  // TR-safe kanonik (GroupID için güvenli)
  const canon = (s) => String(s ?? "")
    .toUpperCase()
    .replaceAll("İ","I").replaceAll("Ş","S").replaceAll("Ğ","G")
    .replaceAll("Ü","U").replaceAll("Ö","O").replaceAll("Ç","C")
    .replace(/[^\w]+/g,"") // sadece [A-Z0-9_]
    .trim();

  // Tek noktadan GRUP KEY üretimi (altkategori/tip KULLANMIYORUZ → sapma engellendi)
  // delimiter olarak '-' kullanıyoruz; sheetKey zaten kanonik ve tire içermez.
  const buildGroupKey = ({ kind, sheetKey, baseKey, sabit }) => {
    const parts = [kind, sheetKey, `BK${String(baseKey).padStart(3,"0")}`];
    if (sabit != null) parts.push(`S${sabit}`);
    return parts.join("-");
  };

  // dash normalize (1–3, 1—3, 1-3 hepsini 1-3 yap)
  const DASH_REGEX = /[\-\u2010\u2011\u2012\u2013\u2014\u2015\u2212\uFE58\uFE63\uFF0D]/g;
  const normalizeSayi = (s) => (s ?? "").toString().trim().replace(DASH_REGEX,"-");

  // "SAYI" sütunu: "25-2" → baseKey=25, blankIndex=2
  const parseCloze = (raw) => {
    const s = normalizeSayi(raw);
    const m = s.match(/^\s*(\d+)\s*-\s*(\d+)\s*$/);
    if (!m) return { isCloze:false, baseKey:null, blankIndex:null };
    return { isCloze:true, baseKey:m[1], blankIndex:Number(m[2]) };
  };

  // Başlık satırını bul
const findHeaderRow = (aoa) => {
  const EXPECTED = [
    "SINAVTIPI","SORUTIPI","ALTKATEGORI","SEVIYE","SAYI","SORU",
    "A","B","C","D","E","DOGRUCEVAP","ACIKLAMA","SABIT","METIN",
    "SORUKODU" // <— YENİ
  ];
  for (let r = 0; r < Math.min(5, aoa.length); r++) {
    const row = aoa[r] || [];
    const normalized = row.map(x => normHeader(String(x || "")));
    if (normalized.includes("SORU") && normalized.includes("A") && normalized.includes("B")) {
      const indexByKey = {};
      EXPECTED.forEach(key => {
        const idx = normalized.indexOf(key);
        if (idx !== -1) indexByKey[key] = idx;
      });
      return { headerRowIndex:r, indexByKey };
    }
  }
  return null;
};

// codes: string[]  -> Map<Question_Code, { ID }>
// codes: string[]  -> Map<Question_Code, { ID }>
const fetchExistingByCodes = async (codes) => {
  const out = new Map();
  const uniq = Array.from(new Set(codes.filter(Boolean)));
  console.log(`[CHECK] ${uniq.length} soru kodu kontrol ediliyor...`);

  for (const code of uniq) {
    try {
      // senin endpoint: /getQuestionFindByCode/select/{code}
      const url = API_URLS.findQuestionByCode(code);
      const r = await axios.get(url);

      // bazı API'ler tek nesne, bazıları { data: {...} } dönebilir:
      const arr = Array.isArray(r.data)
        ? r.data
        : r.data?.value
        ? r.data.value
        : r.data
        ? [r.data]
        : [];

      arr.forEach(it => {
        if (it?.Question_Code) {
          out.set(it.Question_Code, { ID: it.ID });
        }
      });
    } catch (err) {
      console.warn(`[WARN] Kod kontrolü başarısız (${code}):`, err?.message);
    }
  }

  console.log(`[CHECK] ${out.size} mevcut soru bulundu.`);
  return out;
};






  console.log("%c[IMPORT] Başlıyor...","background:#222;color:#0f0;padding:2px 6px;border-radius:4px");

  try {
    setUploadModalOpen(true);
    setUploadProgress(0);
    setIsUploading(true);

    const dicts = await buildDictionaries(); // kategori / tip / altKategori / seviye sözlükleri
    const data = await file.arrayBuffer();
    const wb = XLSX.read(data, { type:"array" });

    // "KODACIKLAMA" hariç tüm sayfalar
    const questionSheets = wb.SheetNames.filter(name => name && norm(name) !== "KODACIKLAMA");

    const allQuestionsToCreate = [];

    for (const sheetName of questionSheets) {
      const ws = wb.Sheets[sheetName];
      if (!ws) continue;

      const aoa = XLSX.utils.sheet_to_json(ws, { header:1, defval:"", raw:false });
      const hdr = findHeaderRow(aoa);
      if (!hdr) continue;

      const { headerRowIndex, indexByKey } = hdr;
      const cell = (row,key) =>
        indexByKey[key] !== undefined ? safeCellString(row[indexByKey[key]]) : "";

      let lastKategoriId=null,lastTypeId=null,lastSubcatId=null,lastLevelId=null;

      // Aynı baseKey için girilen SABIT'i gruptakilere uygula
      const lastSabitByBaseKey = new Map();

      // Sayfa bazlı kanonik key (tire yok → parçalarda karışma olmaz)
      const sheetKey = canon(sheetName);

      // PARAGRAF sayfası algısı
      const isParagraphSheet = sheetName.toUpperCase().includes("PARAGRAF");
      let paragraphCounter = 0;
      let lastParagraphText = null;
      let currentParagraphGroupID = null;

      // sheet içi SINGLE sıra sayaç (Question_Code için)
      let singleCounter = 0;

      for (let r = headerRowIndex + 1; r < aoa.length; r++) {
        const row = aoa[r] || [];
        const questionText = cell(row,"SORU");
        if (!questionText) continue;

        // kategori / tip / alt kategori / seviye (forward fill)
        let kategoriId = dicts.catByCode.get(cell(row,"SINAVTIPI").toUpperCase()) || lastKategoriId;
        let typeId     = dicts.typeBySort.get(Number(cell(row,"SORUTIPI")))        || lastTypeId;
        let subcatId   = dicts.subcatByNumber.get(Number(cell(row,"ALTKATEGORI"))) || lastSubcatId;
        let levelId    = dicts.levelByTitle.get(norm(cell(row,"SEVIYE")))          || lastLevelId;

        lastKategoriId = kategoriId; lastTypeId = typeId;
        lastSubcatId   = subcatId;   lastLevelId = levelId;

        if (!kategoriId || !typeId || !subcatId || !levelId) {
          console.warn(`[ATLANDI] Satır ${r+1}: kategori/tip alanı eksik.`);
          continue;
        }

        // --- METIN (sadece PARAGRAF sayfasında anlamlı) ---
        let paragraphText = null;
        if (isParagraphSheet) {
          const metinCell = cell(row, "METIN");
          if (metinCell) {
            // yeni paragraf başladı
            paragraphText = metinCell;
            lastParagraphText = metinCell;
            paragraphCounter += 1;
            currentParagraphGroupID = `PARA-${sheetKey}-${paragraphCounter}`;
          } else if (lastParagraphText) {
            paragraphText = lastParagraphText;
            // groupID aynı kalsın
          } else {
            paragraphText = null;
            currentParagraphGroupID = null;
          }
        }

        // --- SAYI / CLOZE ---
        const sayiRaw = cell(row,"SAYI");
        const { isCloze, baseKey, blankIndex } = parseCloze(sayiRaw);

        // SABIT (gruba dahil olacak şekilde)
        const sabitCell = cell(row,"SABIT");
        const sabitParsed = sabitCell !== "" && isFinite(Number(sabitCell)) ? Number(sabitCell) : null;
        if (isCloze && baseKey && sabitParsed != null) {
          lastSabitByBaseKey.set(baseKey, sabitParsed);
        }
        let sabitValue = null;
        if (isCloze && baseKey) {
          sabitValue = sabitParsed != null ? sabitParsed : (lastSabitByBaseKey.get(baseKey) ?? null);
        } else {
          sabitValue = sabitParsed != null ? sabitParsed : null;
        }

        // CLOZE GroupID / GroupOrder (sadece sheetKey + baseKey (+SABIT))
        let groupId = null;
        let groupOrder = 0;
        if (isCloze && baseKey && blankIndex != null) {
          groupId = buildGroupKey({
            kind: "CLOZE",
            sheetKey,
            baseKey,
            sabit: sabitValue,
          });
          groupOrder = Number(blankIndex); // 1..N
        }

        const excelCode = cell(row, "SORUKODU"); // "" olabilir

        // --- qBody oluştur ---
        const qBody = {
          Question_Title: questionText,
          Question_Desc: cell(row,"ACIKLAMA") || null,
          Question_Category_ID: kategoriId,
          Question_Type_ID: typeId,
          Question_SubCategory_ID: subcatId,
          Level_ID: levelId,
          Blank: !!isCloze,
          Sabit: sabitValue,
          GroupID: groupId,
          GroupOrder: groupOrder,
          Question_Code : excelCode
        };

if (excelCode) {
  qBody.Question_Code = excelCode.trim();
} else if (groupId) {
  // fallback: deterministik üret
  qBody.Question_Code = `${groupId}#${String(groupOrder).padStart(2,"0")}`;
} else {
  singleCounter += 1;
  qBody.Question_Code = `SINGLE-${sheetKey}-${String(singleCounter).padStart(3,"0")}`;
}

  if (paragraphText) qBody.Paragraph_Text = paragraphText;
        if (currentParagraphGroupID) qBody.ParagraphGroupID = currentParagraphGroupID;

        
        // cevaplar
        const answers = ["A","B","C","D","E"]
          .map(k => ({ key:k, text:cell(row,k) }))
          .filter(a => a.text);
        const correct = (cell(row,"DOGRUCEVAP") || "").toUpperCase();

        allQuestionsToCreate.push({ qBody, answers, correct });
      }
    }

    console.log(`[PARSE] Tamamlandı. ${allQuestionsToCreate.length} soru oluştu.`);

    if (allQuestionsToCreate.length === 0) {
      showToast("Bilgi","Yüklenecek soru bulunamadı.",false);
      setUploadModalOpen(false);
      setIsUploading(false);
      return;
    }

    // ========================= Upload =========================
    const allUploadTasks = [];
    let createdCount = 0;
    const errors = [];

    // Excel’den toplanan tüm Question_Code’lar:
const allCodes = allQuestionsToCreate
  .map(x => x.qBody?.Question_Code)
  .filter(Boolean);

// Sunucudaki mevcutları çek
const existingMap = await fetchExistingByCodes(allCodes);
let skippedExisting = 0;


    allQuestionsToCreate.forEach((item, idx) => {
      allUploadTasks.push(async () => {
        try {
          // 1) Soru kaydı


                const qCode = item.qBody?.Question_Code || "";

           if (qCode && existingMap.has(qCode)) {
        // ZATEN VAR → tekrar ekleme (idempotent)
        skippedExisting++;
        return;
      }

                 const qResp = await postWithRetry(API_URLS.addQuestion, item.qBody);
      const questionId = qResp?.data?.ID;
      if (!questionId) throw new Error("API'den Soru ID'si dönmedi.");

          // 2) Cevaplar
          const ansPromises = item.answers.map((ans, i) =>
            postWithRetry(API_URLS.addAnswer, {
              Question_ID: questionId,
              Question_Answer_Title: ans.text,
              TrueCheck: ans.key.toUpperCase() === item.correct.toUpperCase(),
              SortOrder: i + 1,
            })
          );
          await Promise.all(ansPromises);

          createdCount++;
        } catch (err) {
          errors.push({
            index: idx,
            title: item.qBody?.Question_Title?.slice(0,80),
            gid: item.qBody?.GroupID,
            qcode: item.qBody?.Question_Code,
            sabit: item.qBody?.Sabit,
            error: err?.message || String(err)
          });
        }
      });
    });

    await uploadInBatches(allUploadTasks, task => task(), {
      concurrency: 5,
      onProgress: (done, total) => setUploadProgress(Math.round((done/total)*100)),
    });

    console.log("%c[IMPORT] Tamamlandı!","background:#222;color:#0f0;padding:2px 6px;border-radius:4px");
    if (errors.length) console.error("[HATALAR]", errors);
showToast(
  "İşlem Tamamlandı",
  `Eklenen: ${createdCount}, Atlanan (mevcut): ${skippedExisting}, Hata: ${errors.length}`,
  true
);

dispatch(onGetBlogs());

  } catch (err) {
    console.error("Excel yükleme hatası:", err);
    showToast("Kritik Hata","Excel işlenirken beklenmedik hata.", false);
  } finally {
    setUploadModalOpen(false);
    setIsUploading(false);
    if (e.target) e.target.value = null;
  }
};


  return (
    <React.Fragment>
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteUser} onCloseClick={() => setDeleteModal(false)} />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Sorular" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>

                        <button  className="btn-rounded  mb-2 me-2" onClick={handleClick}>Excel Dosyasını Yükle</button>
      <input
        id="fileInput"
        type="file"
        accept=".xlsx, .xls"
        style={{ display: 'none' }}
        onChange={handleFileUpload}
      />

                  <TableContainer
                    columns={columns} data={users} ref={tableRef} isGlobalFilter={true}
                    isAddBlog={true} handleOrderClicks={handleUserClicks} customPageSize={10}
                    className="custom-header-css"
                  />

                  <Modal isOpen={uploadModalOpen} backdrop="static" centered>
  <ModalBody>
    <p className="text-center text-lg font-bold mb-3">Yükleme Devam Ediyor...</p>
    <Progress value={uploadProgress} color="warning" animated />
    <p className="text-center mt-2">{uploadProgress}%</p>
  </ModalBody>
</Modal>

                  <Modal size="xl" isOpen={modal} toggle={toggle} centered onClosed={resetModalState}>
                    <ModalHeader toggle={toggle} tag="h4">{isEdit ? "Soruyu Düzenle" : "Yeni Soru Ekle"}</ModalHeader>
                    <ModalBody>
                      <div className="wizard clearfix">
                        <div className="steps clearfix">
                          <ul>
                            <NavItem className={classnames({ current: activeTab === 1 })}>
                              <NavLink className={classnames({ active: activeTab === 1 })} onClick={() => setActiveTab(1)}>
                                <span className="number">1.</span> Soru Bilgileri
                              </NavLink>
                            </NavItem>
                            <NavItem className={classnames({ current: activeTab === 2 })}>
                              <NavLink className={classnames({ active: activeTab === 2 })} disabled={activeTab < 2}>
                                <span className="number">2.</span> Seçenek Bilgileri
                              </NavLink>
                            </NavItem>
                          </ul>
                        </div>
                        <div className="content clearfix">
                          <TabContent activeTab={activeTab} className="twitter-bs-wizard-tab-content">
                            <TabPane tabId={1}>
                              <Form>
                                <Row>
                                    <Col lg={6}>
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="subCategory">Seviye</Label>
                                      <Input id="subCategory" name="subCategory" type="select"
                                        onChange={validation.handleChange} onBlur={validation.handleBlur}
                                        value={validation.values.subCategory}
                                        invalid={!!(validation.touched.subCategory && validation.errors.subCategory)}>
                                        <option value="">Lütfen Seçim Yapınız</option>
                                        {getCategory.map(item => (
                                          <option value={item.ID} key={item.ID}>{item.Question_SubCategory_Sub_Text}</option>
                                        ))}
                                      </Input>
                                      {validation.touched.subCategory && validation.errors.subCategory &&
                                        <FormFeedback type="invalid">{validation.errors.subCategory}</FormFeedback>}
                                    </FormGroup>
                                  </Col>
                                  <Col lg={6}>
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="subCategory">Kategori</Label>
                                      <Input id="subCategory" name="subCategory" type="select"
                                        onChange={validation.handleChange} onBlur={validation.handleBlur}
                                        value={validation.values.subCategory}
                                        invalid={!!(validation.touched.subCategory && validation.errors.subCategory)}>
                                        <option value="">Lütfen Seçim Yapınız</option>
                                        {getCategory.map(item => (
                                          <option value={item.ID} key={item.ID}>{item.Question_SubCategory_Sub_Text}</option>
                                        ))}
                                      </Input>
                                      {validation.touched.subCategory && validation.errors.subCategory &&
                                        <FormFeedback type="invalid">{validation.errors.subCategory}</FormFeedback>}
                                    </FormGroup>
                                  </Col>
                                </Row>

  <Row>
                                  <Col lg={12}>
 <FormGroup className="mb-3">
    <Label htmlFor="title">Soru</Label>
    <Input
        id="title"
        name="title"
        type="textarea"
        rows="5"        
        placeholder="Soruyu Giriniz"
        onChange={validation.handleChange}
        onBlur={validation.handleBlur}
        value={validation.values.title}
        invalid={!!(validation.touched.title && validation.errors.title)}
    />
    {validation.touched.title && validation.errors.title &&
    <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>}
</FormGroup></Col></Row>

                                <Row>
                                  <Col lg={12}>
                                    <FormGroup>
                                      <Label>Soru Görseli (Opsiyonel)</Label>
                                      <Dropzone
                                        getUploadParams={getUploadParams} onChangeStatus={handleChangeStatus}
                                        maxFiles={1} multiple={false} canRemove={true}
                                        inputContent="Sürükleyin veya tıklayarak seçin"
                                        styles={{ dropzone: { minHeight: 120, maxHeight: 250, border: '1px dashed #ced4da' } }}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Form>
                            </TabPane>
                            <TabPane tabId={2}>
                              <Row>
                                <Col lg={12}>
                                  <h5>Cevap Seçenekleri</h5>
                                  <p className="text-muted">Lütfen seçenekleri girin ve doğru olanı işaretleyin.</p>
                                  {options.map((option, index) => (
                                    <div className="d-flex align-items-center mb-2" key={option.id}>
                                      <div className="flex-grow-1 d-flex align-items-center">
                                        <b className="me-2">{index + 1}.</b>
                                        <Input type="text" value={option.text}
                                          onChange={(e) => handleOptionTextChange(option.id, e.target.value)}
                                          placeholder={`Seçenek ${index + 1}`} className="me-2"
                                        />
                                        <Button outline color={option.correct ? "success" : "secondary"}
                                          onClick={() => setCorrectOption(option.id)}>
                                          <i className={option.correct ? "mdi mdi-check-circle" : "mdi mdi-circle-outline"}></i> Doğru
                                        </Button>
                                      </div>
                                      <Button color="danger" outline className="ms-2" onClick={() => removeOption(option.id)}>
                                        <i className="mdi mdi-delete"></i>
                                      </Button>
                                    </div>
                                  ))}
                                  <Button color="primary" outline onClick={addOption} className="mt-2">
                                    <i className="mdi mdi-plus"></i> Yeni Seçenek Ekle
                                  </Button>
                                </Col>
                              </Row>
                            </TabPane>
                          </TabContent>
                        </div>
                        <div className="actions clearfix mt-4">
                          <ul role="menu" aria-label="Pagination">
                            <li className={activeTab === 1 ? "previous disabled" : "previous"}>
                              <Link to="#" onClick={() => toggleTab(activeTab - 1)}>Geri</Link>
                            </li>
                            {activeTab < 2 &&
                              <li className="next">
                                <Link to="#" onClick={() => toggleTab(activeTab + 1)}>İleri</Link>
                              </li>
                            }
                            {activeTab === 2 &&
                              <li className="next">
                                <Link to="#" onClick={handleFinalSubmit}>
                                  {isEdit ? 'Değişiklikleri Kaydet' : 'Soruyu Kaydet'}
                                </Link>
                              </li>
                            }
                          </ul>
                        </div>
                      </div>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);